import { buildProductsFromSkuData, indexProducts, filterProducts } from './mask-guide-search.js';

const modal = document.querySelector('[data-mask-guide-modal]');

if (modal) {
  const dialogComponent = modal;
  const dataEl = document.getElementById('mask-guide-data');
  const input = modal.querySelector('[data-mask-guide-input]');
  const results = modal.querySelector('[data-mask-guide-results]');
  const emptyState = modal.querySelector('[data-mask-guide-empty]');
  const count = modal.querySelector('[data-mask-guide-count]');
  const template = modal.querySelector('[data-mask-guide-template]');

  const products = (() => {
    if (Array.isArray(window.RemzzzsMaskSkuData)) {
      return buildProductsFromSkuData(window.RemzzzsMaskSkuData);
    }
    if (!dataEl) return [];
    try {
      const data = JSON.parse(dataEl.textContent || '{}');
      return Array.isArray(data.products) ? data.products : [];
    } catch (error) {
      console.warn('Mask guide data is invalid.', error);
      return [];
    }
  })();

  const indexedProducts = indexProducts(products);

  const renderResults = (items) => {
    if (!results || !template) return;
    results.innerHTML = '';

    items.forEach((item) => {
      const fragment = template.content.cloneNode(true);
      const title = fragment.querySelector('[data-mask-guide-title]');
      const meta = fragment.querySelector('[data-mask-guide-meta]');
      const action = fragment.querySelector('[data-mask-guide-action]');

      if (title) title.textContent = item.name || item.sku || '';
      if (meta) meta.textContent = item.details ? `SKU ${item.sku} - ${item.details}` : `SKU ${item.sku}`;
      if (action) {
        action.setAttribute('href', item.url || '#');
        action.textContent = item.actionLabel || 'Use this liner';
        const actionLabel = item.actionLabel || 'Use this liner';
        action.setAttribute('aria-label', `${actionLabel} for ${item.name || item.sku}`);
      }

      results.appendChild(fragment);
    });

    if (count) {
      count.textContent = `${items.length} result${items.length === 1 ? '' : 's'}`;
    }

    if (emptyState) {
      emptyState.hidden = items.length !== 0;
    }
  };

  const filterResults = (value) => {
    renderResults(filterProducts(indexedProducts, value));
  };

  if (input) {
    input.addEventListener('input', (event) => {
      filterResults(event.target.value);
    });
  }

  renderResults(indexedProducts);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-mask-guide-trigger]');
    if (!trigger) return;

    event.preventDefault();
    dialogComponent.showDialog();

    if (input) {
      input.value = '';
      renderResults(indexedProducts);
      input.focus();
    }
  });
}
